import { IExportColumnModel } from "../../../../../shared/models";

export const TagMatchersColumnList: IExportColumnModel[] = [
]